import { EXERCISE_KEY, EXERCISE_TYPE } from '../../constants'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

function getTypeExerciseUtil (exercise) {
  return getValueReduxUtil(exercise, EXERCISE_KEY.TYPE) ||
    EXERCISE_TYPE.STRENGTH
}

export { getTypeExerciseUtil }
